import styles from "./guidance.module.css";

/**
 * Renders guidance.progress — no phase decisions.
 *
 * @param {{
 *   progress?: {
 *     steps?: Array<{ id: string, label: string, status: 'complete'|'current'|'upcoming' }>,
 *     currentIndex?: number,
 *   } | null,
 *   'aria-label'?: string,
 * }} props
 */
export default function PhaseProgress({ progress, "aria-label": ariaLabel = "Progress" }) {
  const steps = Array.isArray(progress?.steps) ? progress.steps : [];
  if (!steps.length) return null;

  return (
    <nav className={styles.phase} aria-label={ariaLabel} data-testid="guidance-phase-progress">
      <ol className={styles.phaseList}>
        {steps.map((step) => (
          <li
            key={step.id || step.label}
            className={styles.phaseStep}
            data-status={step.status || "upcoming"}
            data-phase-id={step.id}
          >
            <span className={styles.phaseDot} aria-hidden />
            <span className={styles.phaseLabel}>
              {step.status === "current" ? (
                <span className="tra-sr-only">Current: </span>
              ) : null}
              {step.label}
            </span>
          </li>
        ))}
      </ol>
    </nav>
  );
}
